import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query'
import { reportError } from '../../utils/report-error'

const captureNonAxiosError = (error) => {
  // Axios errors (HTTP) are already handled by the axios response
  // interceptor, which decides whether to report (5xx/network) or skip
  // (4xx, MTLS, canceled). Reporting here would duplicate events.
  if (error?.isAxiosError) return
  reportError(error)
}

export const customQueryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: captureNonAxiosError
  }),
  mutationCache: new MutationCache({
    onError: captureNonAxiosError
  }),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 2,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 300000)
    },
    mutations: {
      retry: 2,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30000)
    }
  }
})
